import "@aws-amplify/ui-react/styles.css";

let config = {
  controlPlaneAPI: import.meta.env.VITE_APP_ENDPOINT,
  sentryEnabled: import.meta.env.VITE_SENTRY_ENABLED === "true",
  sentryArn: import.meta.env.VITE_APP_SENTRY || "",
};

// SSO Configuration
// The identity provider name must match exactly what's configured in Cognito
const ssoConfig = {
  // Entra ID (Azure AD) provider name as configured in Cognito
  entraIdProviderName: import.meta.env.VITE_SSO_PROVIDER_NAME || "tui-entra",
  // Enable/disable SSO button on login page
  ssoEnabled: import.meta.env.VITE_SSO_ENABLED !== "false", // Enabled by default
};

// Determine the correct redirect URI based on current environment
// This ensures Amplify uses the right URI for token exchange
const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
const isLocalhost = currentOrigin.includes('localhost');

// Build redirect URI arrays - current origin should be first for Amplify to pick it
const redirectSignInUrls = isLocalhost 
  ? ["http://localhost:5173", import.meta.env.VITE_REDIRECT_SIGN_IN].filter(Boolean)
  : [import.meta.env.VITE_REDIRECT_SIGN_IN, "http://localhost:5173"].filter(Boolean);

const redirectSignOutUrls = isLocalhost
  ? ["http://localhost:5173", import.meta.env.VITE_REDIRECT_SIGN_OUT].filter(Boolean)
  : [import.meta.env.VITE_REDIRECT_SIGN_OUT, "http://localhost:5173"].filter(Boolean);

console.log("Current origin:", currentOrigin);
console.log("Using redirect URIs:", { signIn: redirectSignInUrls, signOut: redirectSignOutUrls });

const amplifyConfig = {
  Auth: {
    Cognito: {
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ["email", "openid", "profile"],
          redirectSignIn: redirectSignInUrls,
          redirectSignOut: redirectSignOutUrls,
          responseType: "code",
        },
      },
      region: import.meta.env.VITE_COGNITO_REGION,
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_APP_CLIENT_ID,
    },
  },
};

export const isSentryEnabled = () => config.sentryEnabled;
export const isSsoEnabled = () => ssoConfig.ssoEnabled;
export const getSsoProviderName = () => ssoConfig.entraIdProviderName;

export { config, amplifyConfig, ssoConfig };

